module.exports = __webpack_public_path__ + "static/images/monet/action_box_icon.svg";